module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySets.6db543e.jpg";